import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type TableRenameModalAction = "confirm" | "cancel";

export function useEmitTableRenameModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: TableRenameModalAction) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.TableRenameModal,
        optionSelected,
      });
    },
    [accountId],
  );

  return { emit };
}
